// extracted by mini-css-extract-plugin
module.exports = {"fontSizeSmall":"style-module_fontSizeSmall__GzxELxfhV2J0nI33lzgp"};